import React from 'react';
import clsx from 'clsx';
import { type DraggableProvided, type DraggableStateSnapshot } from 'react-beautiful-dnd';
import { Card, CardContent, CardHeader } from '@mui/material';

import Text from 'app/main/components/Text';

export interface BoardCardProps {
	title: string;
	avatar?: React.ReactElement;
	action?: React.ReactElement;
	children: React.ReactElement | React.ReactElement[];
	provided: DraggableProvided;
	snapshot: DraggableStateSnapshot;
}

function BoardCard({ title, avatar, action, children, provided, snapshot }: BoardCardProps) {
	return (
		<div {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef} className="h-full p-8">
			<Card
				className={clsx(
					snapshot?.isDragging ? 'shadow-lg' : 'shadow-none',
					'mb-12 flex h-full w-full cursor-pointer flex-col rounded-lg last:mb-0'
				)}
				variant="outlined"
			>
				<CardHeader
					classes={{ root: 'pb-8', content: 'overflow-auto', action: 'ml-8' }}
					title={title}
					titleTypographyProps={{
						component: Text,
						className: 'line-clamp-2 break-words font-600',
						variant: 'subtitle2'
					}}
					avatar={avatar}
					action={action}
				/>
				<CardContent className="flex h-full flex-col justify-end pb-16 pt-0 last:pb-16">{children}</CardContent>
			</Card>
		</div>
	);
}

export default React.memo(BoardCard);
